import { getTestIds } from '../../utils/TestIds';
export const GetMultiAutocompleteTID = (parentTestId)=>getTestIds({
        parentTestId
    });
